export default "__VITE_ASSET__CYDCWB3e__"